export default {
  page: {
    title: 'Removedor de caracteres especiais',
    subtitle: 'Ferramentas',
  },
  card: {
    title: 'Removedor de caracteres especiais',
  },
  form: {
    text: {
      label: 'Texto Original',
      placeholder: 'Cole seu texto aqui...',
    },
    keepPunctuation: {
      label: 'Manter Pontuação',
    },
    keepLineBreaks: {
      label: 'Manter Quebras de Linha',
    },
    result: {
      label: 'Texto Limpo',
    },
  },
  alert: {
    textCopied: 'Texto copiado!',
  },
};
